import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import { withTranslation } from "react-i18next";

class SocialMediaNoTranslation extends Component {
  static propTypes = {};

  render() {

    const { t } = this.props;

    return (
      <Grid className="common-social-media" columns="equal">
        <Grid.Row stretched>
          <Grid.Column className="instagram" largeScreen={8} mobile={8} tablet={8}>
            <a
              className="social-media-link center-in-parent "
              href="https://www.instagram.com/oripandohostel/"
            >
              <b class="">{t('general.instagram', { framework: 'React' })}</b>
            </a>
          </Grid.Column>
          <Grid.Column className="facebook" largeScreen={8} mobile={8} tablet={8}>
            <a
              className="social-media-link center-in-parent "
              href="https://www.facebook.com/111819130490745/"
            >
              <b class=""> {t('general.facebook', { framework: 'React' })}</b>
            </a>
            {/* <Link to='https://www.instagram.com/oripandohostel/'/> */}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}


const SocialMedia = withTranslation('common')(SocialMediaNoTranslation)

export default SocialMedia;


// WEBPACK FOOTER //
// ./src/features/common/SocialMedia.js